import { render, staticRenderFns } from "./FTextarea.vue?vue&type=template&id=d4506bf6&"
import script from "./FTextarea.vue?vue&type=script&lang=ts&"
export * from "./FTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports